import { createContext } from 'react';

export interface Profile {
  id: string;
  [key: string]: any;
}

interface ProfileContextType {
  profile?: {
    [key: string]: any;
    stripeVerificationStatus?: string;
  };
  domesticCountryCode?: string;
  domesticCurrency?: string;
  timeExpiredDate?: string;
  stripeVerificationStatus?: string;
  loading: boolean;
  domesticLanguages?: string[];
  getProfile: (params?: { bypassCache?: boolean }) => void;
}

export const ProfileContext = createContext<ProfileContextType>(null!);
